import script from "./NewLottery.vue?vue&type=script&setup=true&lang=js"
export * from "./NewLottery.vue?vue&type=script&setup=true&lang=js"

import "./NewLottery.vue?vue&type=style&index=0&id=662db3da&scoped=true&lang=css"

import exportComponent from "D:\\xm\\zhongzai\\qianduan\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-662db3da"]])

export default __exports__